import React, { Fragment } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button } from '@schibsted-svp/react-ui';

import { ComponentForm } from '../components/ComponentForm/ComponentForm';
import { CenteredSpinner } from '../components/CenteredSpinner/CenteredSpinner';
import { ContainerHeader } from '../components/Container/ContainerHeader/ContainerHeader';
import { useComponent } from '../hooks/useComponent';
import { createComponent, updateComponent } from '../services/api/components';
import { withFetchStatus } from '../services/notifier';

import type { ComponentInput } from '../types';
import type { FC } from 'react';

export const Component: FC = () => {
  const navigate = useNavigate();
  const { componentId } = useParams<{ componentId: string }>();

  const {
    data: component,
    isFetching,
    refetch,
  } = useComponent(componentId === 'new' ? undefined : componentId);

  const onSubmit = async ({
    id,
    ...componentDraft
  }: Partial<
    ComponentInput & {
      id?: string;
      pageId?: string;
      index?: number;
    }
  >) => {
    if (id) {
      await withFetchStatus(updateComponent, {
        success: 'Component updated',
        error: 'Failed to update component',
      })(id, componentDraft);
      await refetch();
    } else {
      const component = await withFetchStatus(createComponent, {
        success: 'Component created',
        error: 'Failed to create component',
      })({
        ...componentDraft,
        isShared: true,
      });
      navigate(`/components/${component.id}`, { replace: true });
    }
  };

  return (
    <Fragment>
      <ContainerHeader>
        <Link to="/components">
          <Button type="button" variant="standard">
            Back to components
          </Button>
        </Link>
      </ContainerHeader>
      {isFetching ? (
        <CenteredSpinner />
      ) : (
        <ComponentForm component={component} isStandalone onSubmit={onSubmit} />
      )}
    </Fragment>
  );
};
